var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('div',{staticClass:"text-left "},[_c('h6',[_c('i',{staticClass:"fa fa-check text-primary"}),_vm._v(" "+_vm._s(_vm.antecedente_usuario.antecedente.descripcion))]),_c('span',[_vm._v(_vm._s(_vm.antecedente_usuario.valor))])])])}
var staticRenderFns = []

export { render, staticRenderFns }